// extracted by css-extract-rspack-plugin
module.exports =  {"container":"styles__container___yezyL","content":"styles__content___w3ZjL","logo":"styles__logo___JuvNy","copyright":"styles__copyright____DyUt","image":"styles__image___hAZHX"};